export const REQUEST_STATE = 'REQUEST_STATE'
export const SET_ERROR = 'SET_ERROR'

export const LOGOUT = 'LOGOUT'

//AUTH
export const CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST'
export const CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS'
export const CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE'

// DISPLAY
export const CORE_LOAD_ALL_DISPLAY_REQUEST = 'CORE_LOAD_ALL_DISPLAY_REQUEST'
export const CORE_LOAD_ALL_DISPLAY_SUCCESS = 'CORE_LOAD_ALL_DISPLAY_SUCCESS'
export const CORE_LOAD_ALL_DISPLAY_FAILURE = 'CORE_LOAD_ALL_DISPLAY_FAILURE'

export const CORE_FIND_DISPLAY_INFO_REQUEST = 'CORE_FIND_DISPLAY_INFO_REQUEST'
export const CORE_FIND_DISPLAY_INFO_SUCCESS = 'CORE_FIND_DISPLAY_INFO_SUCCESS'
export const CORE_FIND_DISPLAY_INFO_FAILURE = 'CORE_FIND_DISPLAY_INFO_FAILURE'



// WEBPACK FOOTER //
// ./src/app/redux/types.js